import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-purchase-details-modal',
  templateUrl: './purchase-details-modal.component.html',
  styleUrls: ['./purchase-details-modal.component.scss']
})
export class PurchaseDetailsModalComponent {
  constructor(
    public dialogRef: MatDialogRef<PurchaseDetailsModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { order: any }
  ) { }
}

